import { Component, Output, Input } from "@angular/core";
import * as _ from "lodash";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";

export interface SignedDocumentRejectionResponse {
  remarks: string;
}

@Component({
  selector: "app-signed-document-rejection-modal",
  templateUrl: "./signed-document-rejection-modal.component.html",
  styleUrls: ["./signed-document-rejection-modal.component.scss"],
})
export class SignedDocumentRejectionModalComponent {
  @Output()
  save: Subject<SignedDocumentRejectionResponse> = new Subject<SignedDocumentRejectionResponse>();

  @Input()
  remarks: string;

  constructor(private readonly activeModal: NgbActiveModal) {}

  onClose() {
    this.activeModal.dismiss("Cross click");
  }

  get canSave() {
    return !!this.remarks;
  }

  onSave() {
    this.save.next({ ...this });
    this.activeModal.close();
  }
}
